import { render, staticRenderFns } from "./CardButton.vue?vue&type=template&id=2fe38dc3&scoped=true"
import script from "./CardButton.vue?vue&type=script&lang=js"
export * from "./CardButton.vue?vue&type=script&lang=js"
import style0 from "./CardButton.vue?vue&type=style&index=0&id=2fe38dc3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe38dc3",
  null
  
)

export default component.exports